import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-close",
  "use": "icon-close-usage",
  "viewBox": "0 0 29 30",
  "content": "<symbol viewBox=\"0 0 29 30\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-close\">\n  <line y1=\"-1\" x2=\"25.0952\" y2=\"-1\" transform=\"matrix(0.687096 0.726567 -0.687096 0.726567 6.1 5.4668)\" stroke-width=\"2\" />\n  <line y1=\"-1\" x2=\"25.0952\" y2=\"-1\" transform=\"matrix(0.687096 -0.726567 0.687096 0.726567 6.77717 23.373)\" stroke-width=\"2\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol